<template>
  <a id="botaoAssinar" :href="urlDocumentoVirtualizado" target="_blank" class="assinar__botao-link">
    <i class="fas fa-signature" aria-hidden="true"/>
    Assinar
  </a>
</template>

<script>
export default {
    name: 'BotaoAssinar',
    props: ['urlDocumentoVirtualizado']
}
</script>

<style scoped lang="stylus">

.assinar
  color #888
  &__botao-link
    background-color #fff
    color #888
    padding 5px 10px 5px 5px
    min-width 50px
    text-decoration none

    i
      color #777 !important
      font-size 13px
      top 0

    &:hover, &:active, &:focus
      background-color #e4e4e4
      border 0 !important
</style>
